var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ApiSearch',{attrs:{"postUrl":("gparts/search/" + (this.invGroupId)),"getUrl":"gparts/search","columns":_vm.columns,"itemId":_vm.id,"returnObject":"","placeholder":"Cikk név","disabled":_vm.disabled},on:{"itemSelected":_vm.selected}})}
var staticRenderFns = []

export { render, staticRenderFns }